<template>
    <div class="myProjects">

        <div class="component-container">

            <div class="top" style="height:60px;"> </div>

            <h4 class="mb-6 font-semibold">My Projects/Clients</h4>
            <div v-if="info" style="text-align: center; margin-bottom: 16px; color: red;">{{info}}</div>
            <div class="bg-gray-100 min-h-screen flex flex-col  p-4 rounded-xl">

                <div class="row">
                    <div class="col-12" style="margin:0px; padding:0px; text-align:right;">

                        <div style="position: relative;">
                            <div class="btn btn-success" style="width: 250px; margin:16px 0; font-weight:normal;" @click="addNewProject">
                                Add a new project/client
                                <svg style="margin-left: 4px;" width="24px" height="24px" viewBox="-2.4 -2.4 28.80 28.80" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-2.4" y="-2.4" width="28.80" height="28.80" rx="14.4" fill="#ffffff" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 6L12 18" stroke="#6655e3" stroke-width="2" stroke-linecap="round"></path> <path d="M18 12L6 12" stroke="#6655e3" stroke-width="2" stroke-linecap="round"></path> </g></svg>
                            </div>
                            <div class="popup-indicator-add-project"  v-show="firstAddProjectPopup">
                                <div class="popup-background" style="width: 260px;">
                                    <div style=" cursor: pointer;" @click="setFirstTimeProjectPopup()">
                                        <i class="material-icons" style="color: #6655e3; font-size: 12px;">close</i>
                                    </div>
                                    <div style="font-size: 10px; padding: 4px 8px 8px 8px; text-align: center; margin-top: -5px;" > Click here to add a new project </div>
                                </div>
                                <div class="popup-indicator">

                                </div>    
                               
                            </div>
                        </div>
                       


                        <div class="text-right" style="clear:both;">
                            <select class="dropdown" style="max-width: 230px; margin: 0 auto 16px auto; padding: 4px 8px; border: 1px solid #ccc; border-radius: 5px;" v-model="SelectedStatus">
                                <option value="0">Current Projects</option>

                                <option value="2">Pending Projects</option>
                                <option value="1">Archived/Finished Projects</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="contract-limit" v-if="!isFreeAccount()" v-html="computeClientContractUsage()"></div>
                <div class="contract-limit" v-if="!isFreeAccount()" v-html="computeSubcontractorContractUsage()"></div>
                <div class="row">

                    <div class="row box" style="width:100%; display:flex;background-color:white; border-radius:0px; border:none; padding:0px; padding-top:12px; position:relative;" v-for="(item, index) in paginatedProjects()" v-bind:key="item">
                        <div class="col-12 col-md-3 col-sm-5">
                            <div style="display:inline-block;">
                                <div class="name">{{item.Name}} <div v-if="!item.IsOwner" class="info">- This project is managed by {{item.OwnerName}}</div></div>
                                <div class="date">{{item.CreatedDate}}</div>
                                <div class="info" v-if="item.IsOwner">{{item.Address}}</div>
                                <div class="info" v-else>You are a {{getUserType(item)}}</div>


                                <div style="display: flex; gap: 10px; align-items:center;">
                                    <div class="border" style="display:flex; width:fit-content; margin-left:16px; vertical-align:top; padding: 4px; margin:8px 0px; gap:10px; height:30px;" v-if="item.IsOwner && (item.Client.Phone || item.Client.Email )">
                                        
                                        <n-popselect v-if="item.Clients.length > 1" 
                                            :options="renderClientPhoneOptions(item.Clients)" 
                                            trigger="click"
                                            @update:value="handlePhoneSelect" >
                                                <i class="btn-call"></i>
                                        </n-popselect>
                                        
                                        <a v-else :href="'tel:' + item.Client.Phone" class="btn-call"></a>

                                        <n-popselect v-if="item.Clients.length > 1" 
                                            :options="renderClientEmailOptions(item.Clients)" 
                                            trigger="click"
                                            @update:value="handleEmailSelect" >
                                                <i class="btn-email"></i>
                                        </n-popselect>
                                        <a v-else :href="'mailto:' + item.Client.Email" class="btn-email"></a>
                                    </div>

                                    <div v-if="item.IsOwner" style="display:none;">
                                        <div class="button purple-button" v-if="item.Status == 0" @click="updateProjectStatus(item.Id, 1)">Move to Archive</div>
                                        <div class="button purple-button" v-else @click="updateProjectStatus(item.Id, 0)">Move to Current</div>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div  class="contracts-container">
                            <div>
                               
                                <div style=" text-align:center;  ">
                                    <!-- Client Contracts -->
                                    <div class="project-status" style="width:280px; text-align:right;" v-html="projectStatus(item)"></div>
                                    <div class="project-status-box" style="vertical-align: top; width: 280px;">

                                        <div class="border" v-if="item.Client.Contracts != null && item.Client.Contracts.length > 0"
                                             style="padding: 14px 8px 10px 8px; margin: 0px 0px 8px 0px; text-align: center; cursor: pointer ; display:flex;"
                                             @click="displayClientContracts(item.Client.Contracts, item.Name, item.Id, item.Comments, item.IsOwner)">
                                            <div style="width:50px;">


                                                <div class="icon-container">
                                                    <div class="icon">
                                                        <img src="../assets/images/new/CONTRACTSPURPLE.png" alt="Icon" style="width: 20px; height: 20px;">
                                                    </div>
                                                    <div class="badge">{{getContractsNumbers(item.Client.Contracts)}}</div>
                                                </div>
                                            </div>
                                            <div class="small-text" style="margin: 4px 16px; flex:1;" v-if="item.IsOwner" v-html="contractStatus(item)"></div>
                                            <div class="small-text" style="margin: 4px 16px; flex: 1;" v-if="!item.IsOwner">Contracts Received From Contractor</div>

                                        </div>

                                        <div v-else style="visibility: hidden; display: none;">
                                            <div style="width:50px;">


                                                <div class="icon-container">
                                                    <div class="icon">
                                                        <img src="../assets/images/new/CONTRACTSPURPLE.png" alt="Icon" style="width: 20px; height: 20px;">
                                                    </div>
                                                    <div class="badge">{{item.Client.Contracts.length}}</div>
                                                </div>
                                            </div>
                                            <div class="small-text" style="margin: 4px 16px; flex: 1;" v-html="contractStatus(item)"></div>
                                        </div>


                                    </div>

                                    <!-- Subcontractors -->
                                    
                                    <div class="project-status" style="width:280px; text-align:right;" v-html="projectStatusForSub(item)"></div>
                                    <div class="project-status-box" style="vertical-align: top; width:280px;">
                                        <div class="border" v-if="item.Subcontractors != null && item.Subcontractors.length > 0"
                                             style="padding: 14px 8px 10px 8px; margin: 0px 0px 8px 0px; text-align: center; cursor: pointer; display: flex;"
                                             @click="displaySubContractorList(item.Subcontractors, item.Id, item.IsOwner)">
                                            <div style="width:50px;">
                                                <div class="icon-container">
                                                    <div class="icon">
                                                        <img src="../assets/images/new/SUBCONTRACTORS.png" alt="Icon" style="height: 20px; width: auto;">
                                                    </div>
                                                    <div class="badge">{{item.Subcontractors.length}}</div>
                                                </div>
                                            </div>
                                           
                                            <div class="small-text" style="margin: 4px 16px; flex:1;">{{infoSubContracts}}</div>
                                        </div>
                                        <div v-else style="visibility: hidden; display:none;">
                                            <div style="width:50px;">
                                                <div class="icon-container">
                                                    <div class="icon">
                                                        <img src="../assets/images/new/SUBCONTRACTORS.png" alt="Icon" style="height: 20px; width: auto;">
                                                    </div>                                                   
                                                </div>
                                            </div>
                                            <div class="small-text" style="margin: 4px; flex: 1;">Subcontractors</div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                      
                            <n-dropdown :options="menuOptionsForItem(item)" trigger="click" v-if="item.IsOwner" placement="bottom-end" @select="handleSelect" style="width:fit-content; border-radius:10px;" :render-label="renderDropdownLabel">
                            
                                <div class="purple-button">
                                    Manage  <br />Project/Client <i class="icon-dropdown"></i>
                                </div>
                            
                            </n-dropdown>

                            <div class="popup-create-contract" v-show="isFirstProject && index == 0">

                                <div class="popup-background">
                                    <div style=" cursor: pointer; text-align: right;" @click="isFirstProject = !isFirstProject;">
                                        <i class="material-icons" style="color: #6655e3; font-size: 12px;">close</i>
                                    </div>
                                    <div style="font-size: 12px; padding: 4px 16px 8px 16px;"> Click here and create your first agreement  </div>
                                </div>
                                <div class="popup-indicator">

                                </div>

                            </div>
                       

                    </div>



                </div>

                <div class="row" style="display:flex; justify-content:center; flex:1;">
                    <n-pagination v-model:page="page" :page-count="pageCount" style="width:fit-content; height:fit-content;align-self:end;" />
                </div>
            </div>

            <FirstProjectModal v-show="showFirstProjectModal" @close-modal="showFirstProjectModal = false" />
            <ProjectInteractionModal v-show="showProjectInteractionModal" @close-modal="showProjectInteractionModal = false" />

        </div>

        <AddProjectModal v-show="showModal" @close-modal="showModal = false" @save="save" />
        <SubcontractorModal v-show="showSubcontractorModal" @close-modal="showSubcontractorModal = false" @save="save" ref="profile" @saveProfile="saveProfile" @addToProject="addToProject" @alertMessage="alertMessage" />

        <ClientContractModal v-show="showClientContractModal" @close-modal="showClientContractModal = false" ref="clientContracts" @refresh="getProjects" @uploadSigned="showUploadSigned" @showReminder="displayReminderModal" />

        <SubcontractorsModal v-show="showSubcontractorListModal" @close-modal="showSubcontractorListModal = false" ref="subcontractors" @uploadSigned="showUploadSigned" @editSubContractor="editSubContractor" @delSubContractor="getProjects" @refresh="getProjects" />

        <UploadSignedModal v-show="showUploadSignedModal" @close-modal="showUploadSignedModal = false" ref="uploadSigned" @refresh="getProjects" />

        <PaymentReminderModal v-show="showReminderModal" @close-modal="showReminderModal = false" ref="paymentReminder" @alertMessage="alertMessage" @refresh="getProjects" />


        <CustomPopup
          :visible="showPopup"
          :icon="popupIcon"
          :iconSrc="popupIconSrc"  
          :iconColor="iconColor"
          :title="popupTitle"
          :content="content"
          :cancelText="cancelText"
          :confirmText="confirmText"
          :confirmButtonType="confirmButtonType"
          :confirmAction="currentConfirmAction"
          :autoClose="autoClose"
          @cancel="onCancel"
        />

        <FirstTimePopup 
                    :visible="showFirstTimePopup"
                    :title="firstTimePopupTitle"
                    :content="firstTimeContent" 
                    :confirmText="firstTimeConfirmText"
                    :confirmAction="firstTimeCurrentConfirmAction" 
                    @cancel="closeFirstTimePopup" />
    </div>
</template>

<script>
    import AddProjectModal from './modals/AddProjectModal.vue';
    import SubcontractorModal from './modals/SubcontractorModal.vue';

    import FirstProjectModal from './modals/FirstProjectModal.vue';
    import ProjectInteractionModal from './modals/ProjectInteractionModal.vue';

    import ClientContractModal from './modals/ClientContractsModal.vue';
    import SubcontractorsModal from './modals/SubcontractorsModal.vue';

    import PaymentReminderModal from './modals/PaymentReminderModal.vue';


    import UploadSignedModal from './modals/UploadSignedModal.vue';

    import CustomPopup from './modals/CustomPopup.vue';

    import FirstTimePopup from './modals/FirstTimePopup.vue';

    import { isNullOrEmpty, isEmail, isPhoneNumber, isValidatePassword, toCamelCase, toDateFormat, formatCurrency } from '@/composables/utils';

    export default {
        components: {
            FirstTimePopup, AddProjectModal, SubcontractorModal, FirstProjectModal, ProjectInteractionModal,
            ClientContractModal, SubcontractorsModal, UploadSignedModal, CustomPopup, PaymentReminderModal
        },
        data() {
            return {
                Projects: [],
                showModal: false,
                showSubcontractorModal: false,

                showFirstProjectModal: false,
                showProjectInteractionModal: false,
                showClientContractModal: false,
                showSubcontractorListModal: false,

                showUploadSignedModal: false,

                infoClientContracts: "Contracts sent to this Client",
                infoSubContracts: "Sub-Contractors for this project",

                menuOptions: [{
                    label: "Make Contract For This Client",
                    key: "makecontract"

                },
                {
                    label: "Add a Sub-Contractor to this Project",
                    key: "addsub"

                },
                {
                    label: "Edit Client / Project Details",
                    key: "editproject"

                },
                {
                    label: "Delete this Project",
                    key: "delete"

                },
                ],

                PersonalInfo: {
                    Business: {},

                },
                selectedProjectId: "",
                UserId: null,
                UserName: null,
                SelectedStatus: 0,

                info: "",

                page: 1, // Current page
                pageSize: 10, // Number of projects per page
                pageCount: 1, // Total number of pages, initially set to 1

                //Custom Popup
                showPopup: false,
                popupIcon: null, // Set to null since we'll use an image
                popupIconSrc: '', // Use this variable to hold the image path
                iconColor: '',
                popupTitle: '',
                content: '',
                cancelText: '',
                confirmText: '',
                confirmButtonType: 'primary',
                currentConfirmAction: null,
                autoClose: false,

                //First Time Popup
                showFirstTimePopup: false,
                firstTimePopupTitle: 'Need To Create A Contract?',
                firstTimeContent: 'If you have a new client or want to draft a contract for an existing one, click here to get started.',
                firstTimeConfirmText: 'OK',
                firstTimeCurrentConfirmAction: null,

                //first project indicator
                isFirstProject: false,
                firstAddProjectPopup: false,

                //reminder popup for millestone or percentage.
                showReminderModal: false,

            }
        },
        mounted() {
            this.UserId = this.$core.data.UserInfo.Id;
            this.UserName = this.$core.data.UserInfo.UserName;

            //console.log("UserInfo", this.$core.data.UserInfo);
            if (this.$core.data.UserInfo.Metadata?.IsRestricted) {
                var option = this.menuOptions.find(m => m.key == 'makecontract');
                option.label = "Make Contract For This Client (Unsubscribed)";
                option.disabled = true;

                option = this.menuOptions.find(m => m.key == 'editproject');
                option.label = "Edit Client / Project Details (Unsubscribed)";
                option.disabled = true;

                this.info = "In order to generate agreements to your Clients and Sub-Contractors you must first subscribe.";

            }

            this.$core.reloadUserInfo();


            this.getProjects();


        },

        watch: {
            SelectedStatus() {
                this.page = 1; // Reset the page to 1 when SelectedStatus changes
            }
        },

        methods: {

            isFreeAccount() {
                return this.$core.data.UserInfo.Metadata.Subscription.Plan.Type == 9;
            },

            computeClientContractUsage() {
                const quota = this.$core.data.UserInfo.Metadata.Subscription.ClientContractQuota;
                const used = this.$core.data.UserInfo.Metadata.Subscription.ClientContractUsed;

                let str = `${used}/${quota} Client Contracts Made Until ${toDateFormat(this.$core.data.UserInfo.Metadata.Subscription.EndTime, 'MMM D, YYYY')}`;

                if (this.$core.data.UserInfo.Metadata.Subscription.ClientContractBonus > 0) {
                    str += ` <span style='background-color:yellow'>(${this.$core.data.UserInfo.Metadata.Subscription.ClientContractBonusUsed}/${this.$core.data.UserInfo.Metadata.Subscription.ClientContractBonus} Welcome Bonus Used) </span>`
                }
                return str;
            },
            computeSubcontractorContractUsage() {
                const quota = this.$core.data.UserInfo.Metadata.Subscription.SubcontractorContractQuota;
                const used = this.$core.data.UserInfo.Metadata.Subscription.SubcontractorContractUsed;

                let str = `${used}/${quota} Sub-Contractor Contracts Made Until ${toDateFormat(this.$core.data.UserInfo.Metadata.Subscription.EndTime, 'MMM D, YYYY')}`;


                if (this.$core.data.UserInfo.Metadata.Subscription.SubcontractorContractBonus > 0) {
                    str += ` <span style='background-color:yellow'>(${this.$core.data.UserInfo.Metadata.Subscription.SubcontractorContractBonusUsed}/${this.$core.data.UserInfo.Metadata.Subscription.SubcontractorContractBonus} Welcome Bonus Used) </span>`
                }
                return str;

            },

            displayReminderModal(data) {
                this.showClientContractModal = false;

                //console.log("displayReminderModal", data);
                this.$refs.paymentReminder.dataUpdate(data);
                this.showReminderModal = true;

            },

            paginatedProjects() {
                // First, filter the projects based on the selected status
                const filteredProjects = this.Projects.filter(m => m.Status == this.SelectedStatus);

                // Update pageCount based on filtered results and pageSize
                this.pageCount = Math.ceil(filteredProjects.length / this.pageSize);

                // Return the paginated results for the current page
                const start = (this.page - 1) * this.pageSize;
                const end = start + this.pageSize;

                //console.log("paginatedProjects", filteredProjects);
                return filteredProjects.slice(start, end);
            },

            renderClientPhoneOptions(clients) {
                var options = [];

                clients.forEach(item => {
                    options.push({
                        label: item.FirstName + " " + item.LastName,
                        value: item.Phone
                    });
                });

                return options;
            },

            handlePhoneSelect(phone) {
                if (phone) {
                    window.location.href = `tel:${phone}`;
                }
            },

            renderClientEmailOptions(clients) {
                var options = [];

                clients.forEach(item => {
                    options.push({
                        label: item.FirstName + " " + item.LastName,
                        value: item.Email
                    });
                });

                return options;
            },

            handleEmailSelect(email) {
                if (email) {
                    window.location.href = `mailto:${email}`;
                }
            },


            renderDropdownLabel(option) {
                const { key, item } = JSON.parse(option.key);

                var iconCss = "btn-new";

                switch (key) {
                    case 'makecontract':
                        iconCss = "btn-new";
                        break;
                    case 'addsub':
                        iconCss = "btn-add-sub";
                        break;
                    case 'editproject':
                        iconCss = "btn-edit";
                        break;
                    case 'delete':
                        iconCss = "btn-delete";
                        break;
                    case 'movetoarchive':
                        iconCss = "btn-archive";
                        break;
                    case 'movetocurrent':
                        iconCss = "btn-current";
                        break;
                    case 'movetopending':
                        iconCss = "btn-pending";
                        break;

                }

                var className = "custom-dropdown-option";

                if (option.label == "Delete this Project" && item.IsDeletable == false) {
                    option.disabled = true;
                    if (option.label.indexOf("NA") == -1)
                        option.label += " NA";
                    className += " disabled";
                }

                return (
                    <div class={className}>
                        {/* Use className instead of class in JSX */}
                        <span class={iconCss}></span>
                        <span class="custom-option-label">{option.label}</span>
                    </div>
                );
            },
            menuOptionsForItem(item) {
                var options = this.menuOptions.map(option => ({
                    ...option,
                    item,  // Add item reference to each option
                    key: JSON.stringify({ key: option.key, item }),
                }));

                if (item.Status == 0) {
                    options.push({ label: 'Move Project / Client to Pending', key: JSON.stringify({ key: 'movetopending', item }) });
                    options.push({ label: 'Finish / Archive Project', key: JSON.stringify({ key: 'movetoarchive', item }) });

                } else if (item.Status == 1) {
                    options.push({ label: 'Move Project / Client to Current Projects', key: JSON.stringify({ key: 'movetocurrent', item }) });
                    options.push({ label: 'Move Project / Client to Pending', key: JSON.stringify({ key: 'movetopending', item }) });
                } else {
                    options.push({ label: 'Move Project / Client to Current Projects', key: JSON.stringify({ key: 'movetocurrent', item }) });
                    options.push({ label: 'Finish / Archive Project', key: JSON.stringify({ key: 'movetoarchive', item }) });
                }

                return options;
            },

            handleSelect(serializedKey) {
                const { key, item } = JSON.parse(serializedKey);

                switch (key) {
                    case 'makecontract':
                        this.makeContract(item.Id);
                        break;
                    case 'addsub':
                        this.addSubcontractor(item);
                        break;
                    case 'editproject':
                        this.edit(item);
                        break;
                    case 'delete':
                        this.del(item);
                        break;
                    case 'movetoarchive':
                        this.updateProjectStatus(item.Id, 1);
                        break;
                    case 'movetocurrent':
                        this.updateProjectStatus(item.Id, 0);
                        break;
                    case 'movetopending':
                        this.updateProjectStatus(item.Id, 2);
                        break;

                }
            },

            getContractsNumbers(contracts) {
                var total = 0;
                contracts.forEach(item => {
                    var amended = contracts.filter(m => m.OriginalId == item.Id);

                    if (amended.length == 0) {
                        total++;

                    }

                });
                return total;
            },

            replaceSpecificObjectsWithSomeString(json, targetKey, targetValue) {
                if (typeof json !== 'object' || json === null) {
                    return json;
                }

                if (Array.isArray(json)) {
                    return json.map(item => this.replaceSpecificObjectsWithSomeString(item, targetKey, targetValue));
                } else {
                    const newObject = {};
                    for (const key in json) {
                        if (key === targetKey && typeof json[key] === 'object' && json[key] !== null) {
                            newObject[key] = targetValue;
                        } else {
                            newObject[key] = this.replaceSpecificObjectsWithSomeString(json[key], targetKey, targetValue);
                        }
                    }
                    return newObject;
                }
            },

            OLD_projectStatus(project) {
                if (!project.IsOwner) {
                    return "";
                }
                let _p = this.replaceSpecificObjectsWithEmptyString(project, 'Terms', ['===== Replaced ===='])
                console.log("Project ===>", _p);

                var status = "";
                var total = 0;
                var count = 0;// to count how many contracts for client has been signed.
                if (project.Client.Contracts.length == 0) {
                    status = "<span style='color:mediumseagreen; font-weight:bold;'>New Client</span>";
                } else {

                    project.Client.Contracts.forEach(item => {
                        var amended = project.Client.Contracts.filter(m => m.OriginalId == item.Id);

                        if (amended.length == 0) {
                            total++;
                            if (item.Status !== 'Signed') {
                                count++;
                            }
                        }

                    });
                    if (count == 0) {// all contracts signed.
                        status = `<span style='color:green; background-color:lightgreen; font-weight:bold;'>&nbsp;All Contracts Signed!&nbsp;</span>`;
                    } else {
                        if (project.Client.Contracts.length == 1) {
                            status = `<span style='color:green; background-color:lightgreen; font-weight:bold;'> &nbsp;${total} contract sent &nbsp;</span><span style='margin-left:4px; background-color:lightcoral; color:white;'>&nbsp; ${count} contract unsigned &nbsp;</span>`;
                        } else {

                            if (count == 1) {
                                status = `<span style='color:green; background-color:lightgreen;font-weight:bold;'> &nbsp;${total} contracts sent&nbsp; </span><span style='margin-left:4px; background-color:lightcoral; color:white;'>&nbsp; ${count} contract unsigned&nbsp; </span>`;
                            } else {
                                status = `<span style='color:green; background-color:lightgreen;font-weight:bold;'> &nbsp;${total} contracts sent &nbsp;</span><span style='margin-left:4px; background-color:lightcoral; color:white;'>&nbsp; ${count} contracts unsigned&nbsp; </span>`;
                            }

                        }

                    }

                }

                return status;
            },
            getPracticalContracts(contracts) {
                var amended = contracts.filter(m => m.OriginalId != null);
                if (amended.length == 0) {
                    return contracts;
                } else {
                    let orgIds = amended.map(x => x.OriginalId);
                    let ret = contracts.filter(x => !orgIds.includes(x.Id));
                    return ret;
                }
            },
            projectStatus(project) {
                if (!project.IsOwner) {
                    return "";
                }
                let _p = this.replaceSpecificObjectsWithSomeString(project, 'Terms', ['===== Replaced ===='])
                let _Contracts = this.getPracticalContracts(_p.Client.Contracts);

                var status = "";
                if (_Contracts.length == 0) {
                    status = "<span style='color:mediumseagreen; font-weight:bold;'>New Client</span>";
                } else {

                    let signed = _Contracts.filter(x => x.Status === 'Signed');
                    let unsigned = _Contracts.filter(x => x.Status !== 'Signed');
                    let contractsTxt = (_Contracts.length != 1) ? "Contracts" : "Contract";
                    if (signed.length == _Contracts.length) {// all contracts signed.
                        status = `<span style='color:green; background-color:lightgreen; font-weight:bold;'>&nbsp;All Contracts Signed&nbsp;</span>`;
                    } else {
                        contractsTxt = (signed.length != 1) ? "contracts" : "contract";
                        status = (signed.length > 0) ? `<span style='color:green; background-color:lightgreen;font-weight:bold;'> &nbsp;${signed.length} ${contractsTxt} Signed &nbsp; </span>` : '';
                        contractsTxt = (unsigned.length != 1) ? "contracts" : "contract";
                        status += (unsigned.length > 0) ? `<span style='margin-left:4px; background-color:lightcoral; color:white;'>&nbsp; ${unsigned.length} ${contractsTxt} unsigned &nbsp; </span>` : '';
                    }

                }

                return status;
            },

            contractStatus(project) {
                if (!project.IsOwner) {
                    return "Contracts sent to this Client";
                }
                let _p = this.replaceSpecificObjectsWithSomeString(project, 'Terms', ['===== Replaced ===='])
                let _Contracts = this.getPracticalContracts(_p.Client.Contracts);
                var info = "Contracts sent to this Client";

                const drafts = _Contracts.filter(c => c && c.Status && String(c.Status).toLowerCase() === 'draft');
                const sentContracts = _Contracts.filter(c => !(c && c.Status && String(c.Status).toLowerCase() === 'draft'));

                // Case: only drafts
                if (drafts.length > 0 && sentContracts.length === 0) {
                    // The user requested this exact language for only-draft scenario
                    info = `Draft Contracts sent to this Client`;
                    return info;
                }

                
                // If mixture (drafts exist alongside sentContracts), append the draft summary on a new line
                if (drafts.length > 0 && sentContracts.length > 0) {
                    const draftTxt = drafts.length === 1 ? "Draft Contract" : "Draft Contracts";
                    info = `Contracts sent to this Client <br /> + ${drafts.length} ${draftTxt} made/pending`;
                }

                return info;
            },

            OLD_projectStatusForSub(project) {
                if (!project.IsOwner) {
                    return "";
                }
                var status = "";
                var total = 0;
                var count = 0;
                for (var i = 0; i < project.Subcontractors.length; i++) {
                    var contracts = project.Subcontractors[i].Contracts;

                    contracts.forEach(item => {

                        var amended = contracts.filter(m => m.OriginalId == item.Id);

                        if (amended.length == 0) {
                            total++;
                            if (item.Status !== 'Signed') {
                                count++;
                            }
                        }

                    });
                }

                if (total > 0) {
                    if (count == 0) {// all contracts signed.
                        status = `<span style='color:green; background-color:lightgreen; font-weight:bold;'>&nbsp;All Contracts Signed!&nbsp;</span>`;
                    } else {

                        if (total == 1) {
                            status = `<span style='color:green; background-color:lightgreen; font-weight:bold;'> &nbsp;${total} contract sent &nbsp;</span><span style='margin-left:4px; background-color:lightcoral; color:white;'>&nbsp; ${count} contract unsigned &nbsp;</span>`;
                        } else {
                            if (count == 1) {
                                status = `<span style='color:green; background-color:lightgreen;font-weight:bold;'> &nbsp;${total} contracts sent&nbsp; </span><span style='margin-left:4px; background-color:lightcoral; color:white;'>&nbsp; ${count} contract unsigned&nbsp; </span>`;
                            } else {
                                status = `<span style='color:green; background-color:lightgreen;font-weight:bold;'> &nbsp;${total} contracts sent &nbsp;</span><span style='margin-left:4px; background-color:lightcoral; color:white;'>&nbsp; ${count} contracts unsigned&nbsp; </span>`;
                            }
                        }
                    }

                }


                return status;
            },

            projectStatusForSub(project) {
                if (!project.IsOwner) {
                    return "";
                }
                let _p = this.replaceSpecificObjectsWithSomeString(project, 'Terms', ['===== Replaced ===='])


                let _Contracts = this.getPracticalContracts(project.Subcontractors.map(x => x.Contracts).flat());

                //console.log('Sub _Contracts  ===>', _Contracts);

                var status = "";
                if (_Contracts.length == 0) {
                    status = "";
                } else {

                    let signed = _Contracts.filter(x => x.Status === 'Signed');
                    let unsigned = _Contracts.filter(x => x.Status !== 'Signed');
                    let contractsTxt = (_Contracts.length != 1) ? "Contracts" : "Contract";
                    if (signed.length == _Contracts.length) {// all contracts signed.
                        status = `<span style='color:green; background-color:lightgreen; font-weight:bold;'>&nbsp;All Contracts Signed&nbsp;</span>`;
                    } else {
                        contractsTxt = (signed.length != 1) ? "contracts" : "contract";
                        status = (signed.length > 0) ? `<span style='color:green; background-color:lightgreen; font-weight:bold;'>&nbsp;${signed.length} ${contractsTxt} Signed &nbsp; </span>` : '';
                        contractsTxt = (unsigned.length != 1) ? "contracts" : "contract";
                        status += (unsigned.length > 0) ? `<span style='margin-left:4px; background-color:lightcoral; color:white;'>&nbsp; ${unsigned.length} ${contractsTxt} unsigned &nbsp; </span>` : '';
                    }

                }

                return status;
            },

            testPopup() {
                //this.$ui.alert(this, "123", "error", null);

                this.showFirstProjectModal = true;

            },
            showProjectInteractionPopup() {
                this.showProjectInteractionModal = true;
            },
            showFirstProjectPopup() {
                this.showFirstProjectModal = true;
            },
            getUserType(project) {
                var res = "";

                for (var i = 0; i < project.Contracts.length; i++) {
                    var contract = project.Contracts[i];
                    if (contract.Type == 0) {
                        res = "Sub-Contractor";
                    } else {
                        res = "Client";
                    }
                    break;
                }
                return res;
            },
            IsPartyB(contract) {
                return contract.PartyBId == this.UserId || contract.PartyBEmail == this.UserName;
            },
            save() {
                //refresh project list...
                this.showModal = false;
                this.getProjects();
            },

            updateProjectStatus(projectId, status) {
                var message = "Are you sure you want to move this project to archive?";
                var title = "Move Project to Archive";

                this.popupIconSrc = require('@/assets/images/icons/ArchiveIcon.png'); // Replace with your image path
                //console.log("Status", status);
                if (status == 0) {
                    message = "Are you sure you want to move this project to current?";
                    title = "Move Project to Current";

                    this.popupIconSrc = require('@/assets/images/icons/CurrentIcon.png'); // Replace with your image path
                }
                if (status == 2) {
                    message = "Are you sure you want to move this project to pending?";
                    title = "Move Project to Pending";

                    this.popupIconSrc = require('@/assets/images/icons/PendingIcon.png'); // Replace with your image path
                }

                this.showPopup = true;


                //this.popupIcon = 'FieldTimeOutlined';
                this.iconColor = 'red';
                //this.popupIconSrc = require('@/assets/images/icons/PendingIcon.png'); // Replace with your image path
                this.popupTitle = title;
                this.content = message;
                this.cancelText = 'Cancel';
                this.confirmText = 'OK';
                this.confirmButtonType = 'success';
                this.autoClose = false;
                this.currentConfirmAction = () => {
                    this.$core.UpdateProjectStatus(projectId, status).then((res) => {
                        if (res?.Type == 200) {
                            this.getProjects();
                        }
                    });
                };
                /*
                let _this = this;
                this.$confirm(message, title).then(() => {

                    _this.$core.UpdateProjectStatus(projectId, status).then((res) => {
                        if (res?.Type == 200) {
                            _this.getProjects();
                        }
                    });

                });

                */

            },

            setFirstTimeProjectPopup() {
                this.firstAddProjectPopup = false;

                this.$core.data.ShowedFirstTimePopup = false;
                this.$core.setFirstTimeProjectPopup(false);

            },
            getProjects() {

                this.$core.GetProjectList(this.UserId).then((res) => {

                    if (res?.Type == 200) {
                        this.$core.data.Projects = res.Data;
                        this.Projects = res.Data;

                        //console.log("ProjectList", this.Projects);

                        if (!this.Projects || this.Projects.length == 0) {
                            this.showFirstTimePopup = false;

                            this.$core.getFirstTimeProjectPopup();

                            if (this.$core.data.ShowedFirstTimePopup) {

                                this.firstAddProjectPopup = true;

                            } else {
                                this.firstAddProjectPopup = false;

                            }

                        } else {

                            this.$core.data.ShowedFirstTimePopup = false;
                        }

                        if (this.Projects.length == 1 && this.$core.data.IsFirstProject) {
                            this.isFirstProject = true;
                        }


                        //this.infoClientContracts = "Contracts sent to this Client";
                        let _p = this.replaceSpecificObjectsWithSomeString(this.Projects, 'Terms', ['===== Replaced ===='])
                        let _Contracts = this.getPracticalContracts(_p.Client.Contracts || []);
                        const drafts = _Contracts.filter(c => c && c.Status && String(c.Status).toLowerCase() === 'draft');
                        const sentContracts = _Contracts.filter(c => !(c && c.Status && String(c.Status).toLowerCase() === 'draft'));

                        // Case: only drafts
                        if (drafts.length > 0 && sentContracts.length === 0) {
                            // The user requested this exact language for only-draft scenario
                            this.infoClientContracts = "Draft Contracts sent to this Client";
                        }


                        /**
                        if (this.Projects == null || this.Projects.length == 0) {

                            let _this = this;
                            setTimeout(function () {
                                _this.showFirstProjectPopup();
                            }, 1500);

                        } else if (this.Projects.length == 1 && (this.Projects[0].Subcontractors == null || this.Projects[0].Subcontractors.length == 0)) {

                            let _this = this;
                            setTimeout(function () {
                                _this.showProjectInteractionPopup();
                            }, 1500);
                        }
                        **/
                        //console.log("ProjectList", this.Projects);
                    }


                });


            },
            addNewProject() {

                if (this.firstAddProjectPopup) {
                    this.firstAddProjectPopup = false;
                    this.$core.setFirstTimeProjectPopup(false);
                }

                this.$core.data.SelectedClient = null;

                this.$core.data.DisplayPage = 'Project';

                this.$router.push('/Project');
                //this.showModal = true;
                //this.$router.push('/AddProject');
            },
            addSubcontractor(obj) {

                this.selectedProjectId = obj.Id;
                this.PersonalInfo = { Business: {} };
                this.$refs.profile.dataUpdate(this.PersonalInfo, false);
                this.$refs.profile.title = "Add New Sub-Contractor";

                this.showSubcontractorModal = true;
            },
            edit(obj) {

                this.$core.data.DisplayPage = 'Project';
                //this.$core.data.SelectedProject = obj;
                this.$router.push('/Project/' + obj.Id);
            },
            del(obj) {
                let _this = this;
                //check if this project have signed contract.
                //check client contracts
                var hasSigned = false;
                if (obj.Client.Contracts.length != 0) {
                    obj.Client.Contracts.forEach(item => {
                        var amended = obj.Client.Contracts.filter(m => m.OriginalId == item.Id);

                        if (amended.length == 0) {

                            if (item.Status == 'Signed') {
                                hasSigned = true;
                            }
                        }
                    });
                }
                //check subcontrators' contract
                if (!hasSigned) {
                    for (var i = 0; i < obj.Subcontractors.length; i++) {
                        var contracts = obj.Subcontractors[i].Contracts;
                        if (hasSigned) {
                            break;
                        }
                        contracts.forEach(item => {
                            var amended = contracts.filter(m => m.OriginalId == item.Id);

                            if (amended.length == 0) {
                                if (item.Status == 'Signed') {
                                    hasSigned = true;
                                }
                            }

                        });
                    }
                }

                if (hasSigned) {

                    this.showPopup = true;


                    //this.popupIcon = 'FieldTimeOutlined';
                    this.iconColor = 'red';
                    this.popupIconSrc = require('@/assets/images/icons/ErrorIcon.png'); // Replace with your image path
                    this.popupTitle = "Error";
                    this.content = "We are unable to delete this project/client at this time as the contract has already been signed and confirmed for this project/client.";
                    this.cancelText = null;
                    this.confirmText = 'OK';
                    this.confirmButtonType = 'error';
                    this.currentConfirmAction = null;
                    return;
                }

                this.showPopup = true;


                //this.popupIcon = 'FieldTimeOutlined';
                this.iconColor = 'red';
                this.popupIconSrc = require('@/assets/images/icons/DeleteIcon.png'); // Replace with your image path
                this.popupTitle = "Delete Project";
                this.content = "Are you sure you want to delete this project?";
                this.cancelText = 'Cancel';
                this.confirmText = 'Delete';
                this.confirmButtonType = 'error';
                this.autoClose = false;
                this.currentConfirmAction = () => {

                    this.$http.request("delete", "/api/app/project/delete", [obj.Id]).then((res) => {
                        if (res?.Type == 200) {

                            this.showPopup = true;

                            //this.popupIcon = 'FieldTimeOutlined';
                            this.iconColor = 'red';
                            this.popupIconSrc = null // Replace with your image path
                            this.popupTitle = "Success";
                            this.content = "Project Deleted!";
                            this.cancelText = null;
                            this.confirmText = 'OK';
                            this.confirmButtonType = 'success';
                            this.currentConfirmAction = null;
                            this.autoClose = true;

                            _this.getProjects();
                        }
                    });

                };



            },
            openContract(Id) {
                window.open(`https://cs.cellflare.com/cloud/${Id}/pdf`);
            },
            openUrl(url) {
                console.log("open signature url ====>", url);
                window.open(url, '');
            },
            makeContract(Id) {

                if (this.$core.data.UserInfo.Metadata.ClientContractLimit == 0) {
                    this.alertMessage("You have reached your client contract limit for this month.");
                    return;
                }


                //console.log("this.$core.data.Business", this.$core.data.Business);
                if (this.$core.data.Business.Signature == null || this.$core.data.Business.Signature == undefined || this.$core.data.Business.Signature.length == 0) {

                    //console.log("this.$core.data.UserInfo", this.$core.data.UserInfo);
                    this.$alert("Please enter all the mandatory fields including the signature");
                    this.$router.push('/MyProfile/3');
                } else {
                    this.$core.data.DisplayPage = 'Project';
                    this.$router.push('/MakeClientContract/' + Id);
                }
            },

            displayClientContracts(contracts, projectName, projectId, comments, isOwner) {

                let project = this.Projects.find(item => item.Id == projectId);

                let contractorInfo = this.$core.data.Business.FirstName + " " + this.$core.data.Business.LastName;
                if (this.$core.data.Business.Name != null && this.$core.data.Business.Name != '') {
                    contractorInfo += " of " + this.$core.data.Business.Name;
                }
                let msg = `Hello, it appears that ${contractorInfo} is nearing completion of ###Type### at your property, ${project.Address}. As per the terms of your agreement, please have ###Amount### ready to pay the Contractor. If you have any questions please contact the ${contractorInfo} at ${this.$core.data.Business.Phone}. `
                this.$core.data.ReminderMsg = msg;
                //console.log("project", msg);

                this.$refs.clientContracts.dataUpdate(contracts, projectName, projectId, comments, isOwner);
                this.showClientContractModal = true;
            },

            displaySubContractorList(contracts, projectId, isOwner) {

                //add project address to the $core.data
                let project = this.Projects.filter(item => item.Id == projectId)[0];
                //console.log("displaySubContractorList", project);
                let address = project.Address;
                if (project.Unit)
                    address += " Suite " + project.Unit;
                address += "\n";
                address += project.City + ", " + project.Province + " " + project.PostalCode;

                this.$core.data.SelectedProjectAddress = address;


                //console.log("displaySubContractorList", address);

                this.$refs.subcontractors.dataUpdate(contracts, projectId, isOwner);
                this.showSubcontractorListModal = true;
            },

            showUploadSigned(contract) {
                this.$refs.uploadSigned.setContractId(contract);
                this.showUploadSignedModal = true;
            },

            editSubContractor(info) {

                this.showSubcontractorListModal = false;

                //console.log(info);

                this.selectedProjectId = info.ProjectId;


                this.$refs.profile.dataUpdate(info, true);

                this.$refs.profile.title = "Edit Sub-Contractor";

                this.showSubcontractorModal = true;

            },

            sendSubcontractor(projectId, subId) {


                if (this.$core.data.UserInfo.Metadata.Subscription.SubcontractorContractQuota == 0) {
                    this.alertMessage("You have reached your sub-contractor contract limit for this month.");
                    return;
                }

                if (this.$core.data.Business.Signature == null || this.$core.data.Business.Signature === undefined || this.$core.data.Business.Signature == '') {
                    this.$alert("Please enter all the mandatory fields including the signature");
                    this.$router.push('/PersonalInfo/3');
                }
                else {
                    this.$core.data.DisplayPage = 'Project';
                    this.$router.push('/MyProfile/' + projectId + "/" + subId);
                }

            },

            resendContract(contractId) {
                this.$ui.confirm(this, "Send Contract", "Are you sure you want to send this contract?", "question").then(() => {


                    this.$http.request("put", `/api/app/contract/resend?id=${contractId}`).then((res) => {

                        if (res?.Type == 200) {

                            this.showPopup = true;

                            //this.popupIcon = 'FieldTimeOutlined';
                            this.iconColor = 'red';
                            this.popupIconSrc = null // Replace with your image path
                            this.popupTitle = "Success";
                            this.content = "Contract Sent!";
                            this.cancelText = null;
                            this.confirmText = 'OK';
                            this.confirmButtonType = 'success';
                            this.currentConfirmAction = null;
                            this.autoClose = true;

                        }
                    });

                });
            },

            editClientContract(projectid, contractid, obj, token) {

                obj.CommencementDate = obj.CommencementDate.substring(0, 10);
                obj.CompletionDate = obj.CompletionDate.substring(0, 10);

                obj.ProjectId = projectid;

                obj.Token = token;

                this.$core.data.SelectedClientContract = obj;
                this.$core.data.DisplayPage = 'Project';
                this.$router.push('/EditClientContract/' + contractid);
            },


            editContract(projectid, subcontractorid, contractid, obj, token) {

                obj.CommencementDate = obj.CommencementDate.substring(0, 10);
                obj.CompletionDate = obj.CompletionDate.substring(0, 10);

                obj.ProjectId = projectid;
                obj.SubContractorId = subcontractorid;
                obj.Token = token;

                this.$core.data.SelectedSubContract = obj;
                this.$core.data.DisplayPage = 'Project';
                this.$router.push('/EditSubContract/' + contractid);
            },
            cancelContract(contractId, name) {
                this.$ui.confirm(this, "Delete Contract", "Are you sure you want to delete this contract for \"" + name + "\"?", "question").then(() => {

                    this.$http.request("put", `/api/app/contract/cancel?id=${contractId}`).then((res) => {

                        if (res?.Type == 200) {

                            this.showPopup = true;

                            //this.popupIcon = 'FieldTimeOutlined';
                            this.iconColor = 'red';
                            this.popupIconSrc = null // Replace with your image path
                            this.popupTitle = "Success";
                            this.content = "Contract Deleted!";
                            this.cancelText = null;
                            this.confirmText = 'OK';
                            this.confirmButtonType = 'success';
                            this.currentConfirmAction = null;
                            this.autoClose = true;

                        }
                    });

                });
            },

            alertMessage(msg) {


                //this.popupIcon = 'FieldTimeOutlined';
                this.iconColor = 'red';
                this.popupIconSrc = null // Replace with your image path
                this.popupTitle = msg;
                this.content = null;
                this.cancelText = null;
                this.confirmText = 'OK';
                this.confirmButtonType = 'success';
                this.currentConfirmAction = null;
                this.showPopup = true;

                this.autoClose = true;


            },
            addToProject(obj) {
                obj.Business.ProjectId = this.selectedProjectId;

                //console.log("addToProject", obj.Business);

                let _this = this;
                this.$http.request("post", '/api/app/subcontractor/createwithproject', obj.Business).then(res => {

                    console.log("createwithproject", res);


                    if (res?.Type == 200) {
                        _this.PersonalInfo = { Business: {} };
                        _this.$refs.profile.dataUpdate(_this.PersonalInfo);

                        _this.getProjects();

                        this.showPopup = true;

                        //this.popupIcon = 'FieldTimeOutlined';
                        this.iconColor = 'red';
                        this.popupIconSrc = null // Replace with your image path
                        this.popupTitle = "Success";
                        this.content = "Subcontractor Saved!";
                        this.cancelText = null;
                        this.confirmText = 'OK';
                        this.confirmButtonType = 'success';
                        this.currentConfirmAction = null;
                        this.autoClose = true;
                        _this.showSubcontractorModal = false;
                    } else {
                        _this.alertMessage(res.content);
                    }

                }).finally(() => {

                });


            },

            saveProfile(obj) {
                obj.Business.ProjectId = this.selectedProjectId;



                let _this = this;

                if (obj.Business.Id && obj.Business.Id.length > 10) {

                    this.$http.request("put", "/api/app/subcontractor/update", obj.Business).then((res) => {

                        if (res?.Type == 200) {
                            _this.PersonalInfo = { Business: {} };
                            _this.$refs.profile.dataUpdate(_this.PersonalInfo);

                            _this.getProjects();

                            this.showPopup = true;

                            //this.popupIcon = 'FieldTimeOutlined';
                            this.iconColor = 'red';
                            this.popupIconSrc = null // Replace with your image path
                            this.popupTitle = "Success";
                            this.content = "Sub-Contractor Saved!";
                            this.cancelText = null;
                            this.confirmText = 'OK';
                            this.confirmButtonType = 'success';
                            this.currentConfirmAction = null;
                            this.autoClose = true;
                            _this.showSubcontractorModal = false;
                        }


                    });
                } else {
                    this.$http.request("post", "/api/app/subcontractor/create", obj.Business).then((res) => {

                        //console.log("Add contractor", data);


                        if (res?.Type == 200) {
                            _this.getProjects();

                            this.showPopup = true;

                            //this.popupIcon = 'FieldTimeOutlined';
                            this.iconColor = 'red';
                            this.popupIconSrc = null // Replace with your image path
                            this.popupTitle = "Success";
                            this.content = "Subcontractor Added!";
                            this.cancelText = null;
                            this.confirmText = 'OK';
                            this.confirmButtonType = 'success';
                            this.currentConfirmAction = null;

                            _this.showSubcontractorModal = false;

                            this.autoClose = true;
                        } else {
                            _this.alertMessage(res.content);
                        }

                    });
                }

            },

            //Custom Popup
            archiveProject() {
                //console.log('Project archived');
                this.showPopup = false;
            },
            onCancel() {
                this.showPopup = false;
            },

            closeFirstTimePopup() {
                this.showFirstTimePopup = false;
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    
    .contracts-container{flex: 1; width: unset; justify-content: center; align-items:end; margin-right:140px;}

    .purple-button{position:absolute;display:flex; gap:4px; align-items:center;}

     

    .project-status {
        font-size: 10px; margin-bottom:-1.5px;
    }
    .small-text{color:blue;}
    .border {

        border-radius: 4px;
        background-color: #eeecfc;
    }

    .red-bot {
        color: white;
        background-color: red;
        font-size: 12px;
        border-radius: 50%;
        line-height: 20px;
        height: 20px;
        width: 20px;
        text-align: center;
        cursor: pointer;
        margin-top: 2px;
    }

    .swal2-confirm {
        background-color: green;
    }

    .swal2-cancel {
        background-color: red;
    }

    .client-contract-btns-container {
        margin: auto;
    }

    .client-contract-btns {
        width: fit-content;
        display: flex;
        gap: 12px;
        padding: 8px;
        margin: 8px;
    }

    .icon-container {
        position: relative;
        display: inline-block;
    }

    .icon {
        cursor: pointer;
    }

        .icon img {
            width: 30px;
            height: 30px;
        }

    .badge {
        position: absolute;
        width: 14px;
        height: 14px;
        top: 0;
        right: 0;
         
        border-radius: 50%;
        background-color: red;
        color: white;
        font-size: 8px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translate(50%, -50%);
    }

    .popup-indicator-add-project {
        position: absolute;
        right: 270px;
        top:8px;
        display: flex;
        width: 250px;
        height: 60px;
    }
    .popup-indicator-add-project .popup-background{
        background-color: #d2ccff;
        border-radius: 4px;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
        font-weight: bold;
    }
    .popup-indicator-add-project .popup-indicator{
        position: absolute;
        right: -5px;
        top: 23px;
        background-color: #d2ccff;
        width: 14px;
        height: 14px;       
        rotate: 45deg;
        
    }


    .popup-create-contract {
        position: absolute;
        right: 130px;
        top:16px;
        width: 220px;
        height: 70px;
    }

    .popup-create-contract .popup-background{
        background-color: #d2ccff;
        border-radius: 4px;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
        font-weight: bold;
    }
    .popup-create-contract .popup-indicator{
        position: absolute;
        right: 5px;
        top: 30px;
        background-color: #d2ccff;
        width: 14px;
        height: 14px;       
        rotate: 45deg;
        
    }

    .contract-limit{font-size: 12px; color:black; text-align: right;}

    @media screen and (min-width: 540px) {

        .contract-box {
            display: -moz-box;
            display: -webkit-box;
        }
    }

    @media screen and (max-width: 775px) {

        .contract-limit{font-size: 8px;  text-align: left;}

        .purple-button{
            align-self:unset;
        }
        .contracts-container {
            margin-right: 140px;
        }
        

        .client-contract-btns {
            width: fit-content;
            display: flex;
            gap: 12px;
            text-align: center;
            border: 1px solid #ccc;
            border-radius: 10px;
            padding: 8px;
            margin: 8px;
        }

        .contract-box {
            display: table;
        }
    }

    @media (max-width: 768px) {
        /* Mobile version */
        .project-status-box{width: 100% !important;}
        .project-status{width: 100% !important;}
        .contracts-container{margin-right: 0px !important;}
 
        .popup-indicator-add-project{
            top:70px;
            right: 10px;
            z-index: 1;
        }

        .popup-indicator-add-project .popup-indicator{             
            right: 100px;
            top: -5px;            
            rotate: 45deg;           
        }

        .popup-create-contract {        
            top:4px;
            z-index: 1;
        }

    }

</style>

